define('TescoMobile_ClubCard/js/view/savings',['ko', 'uiComponent', 'priceUtils'], function (ko, Component, priceUtils) {
  'use strict';

  return Component.extend({
    defaults: {
      template: 'TescoMobile_ClubCard/savings',
      imports: {
        selectedTariff: "tm-deal-tariff:selectedTariff",
        clubCardPrice: "tm-clubcard-price-provider:clubCardPrice",
        deviceMonthlyPrice: "tm-cca-price:deviceMonthlyPrice",
        selectedTenure: "tm-cca-price:selectedTenure",
        selectedPuf: "tm-cca-price:selectedPuf",
        deviceFullPrice: "tm-cca-price:deviceFullPrice",
        pufClubCardPrice: "tm-clubcard-price-provider:pufClubCardPrice",
        contractType: "contract_type_switcher:contractType"
      }
    },
    initialize: function () {
      this._super();
      this.calculatedSavings = ko.computed(function () {
        var _this$selectedTariff;
        let tenure;
        let puf;
        const deviceMonthlyPrice = parseFloat(this.deviceMonthlyPrice());
        const tariffPrice = parseFloat((_this$selectedTariff = this.selectedTariff()) === null || _this$selectedTariff === void 0 ? void 0 : _this$selectedTariff.price);
        if (this.selectedPuf() === 'all') {
          var _this$deviceFullPrice, _ref, _this$pufClubCardPric;
          tenure = 1;
          puf = parseInt((_this$deviceFullPrice = this.deviceFullPrice()) !== null && _this$deviceFullPrice !== void 0 ? _this$deviceFullPrice : 0) - parseInt((_ref = (_this$pufClubCardPric = this.pufClubCardPrice()) !== null && _this$pufClubCardPric !== void 0 ? _this$pufClubCardPric : this.deviceFullPrice()) !== null && _ref !== void 0 ? _ref : 0);
        } else {
          tenure = parseInt(this.selectedTenure());
          puf = 0;
        }
        const clubCardPrice = parseFloat(this.clubCardPrice());
        return priceUtils.formatPrice(((deviceMonthlyPrice + tariffPrice + puf - clubCardPrice) * tenure).toFixed(2));
      }.bind(this));
    },
    initObservable: function () {
      this._super().observe(['clubCardPrice', 'deviceMonthlyPrice', 'selectedTariff', 'selectedTenure', 'selectedPuf', 'pufClubCardPrice', 'deviceFullPrice', 'contractType']);
      return this;
    },
    isPayM: function () {
      return this.contractType() === 'paym';
    }
  });
});

